import { useLayoutEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { setClerkTokenGetter } from '../../services/authHeaders';

/**
 * Registers Clerk getToken with the API client (must render inside ClerkProvider).
 * useLayoutEffect runs before child useEffect hooks so tokenGetter exists before
 * ChatInterface quota fetch.
 */
const ClerkSessionBridge = () => {
  const { getToken, isLoaded, isSignedIn } = useAuth();

  useLayoutEffect(() => {
    if (!isLoaded) {
      setClerkTokenGetter(null);
      return undefined;
    }
    if (!isSignedIn) {
      setClerkTokenGetter(null);
      return () => setClerkTokenGetter(null);
    }
    setClerkTokenGetter(() => getToken());
    getToken().catch(() => {});
    return () => setClerkTokenGetter(null);
  }, [getToken, isLoaded, isSignedIn]);

  return null;
};

export default ClerkSessionBridge;
